import { makeRequest } from 'utils/requestLogger';

export default (discussion_id, student_to_promote, user_id) =>
  makeRequest(
    'put',
    `/api/live_discussions/${discussion_id}/promote_student/${user_id}`,
    { student_to_promote }
  );



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/queue/promoteStudent.js